/* GLLF "Email me this" (2026-10): sends a grower tool's results to the shopper through Marketing Studio.
   The page lists which results to include (data-lines); the link back keeps the page's own ?zip= so it opens set up.
   Uses the site's bot check (window.gllfFormCheck from gllf-form-guard.js) when it's on the page. */
(() => {
  if (window.__gllfEmailMe) return; window.__gllfEmailMe = true;
  const ENDPOINT = '/apps/gllf-content/email-me';
  const text = (el) => (el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : '');
  function results(box) {
    return String(box.dataset.lines || '').split(';').map((pair) => {
      const i = pair.indexOf('|'); if (i < 1) return null;
      const label = pair.slice(0, i).trim(), value = text(document.querySelector(pair.slice(i + 1).trim()));
      return value && value !== '—' ? `${label}: ${value}`.slice(0, 160) : null;
    }).filter(Boolean).slice(0, 8);
  }
  function wire(box) {
    const form = box.querySelector('form'), msg = box.querySelector('.gllf-emailme__msg'), btn = form.querySelector('button');
    const say = (t, ok) => { msg.hidden = false; msg.textContent = t; msg.className = 'gllf-emailme__msg ' + (ok ? 'is-ok' : 'is-err'); };
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say('Please enter a valid email address.', false); form.email.focus(); return; }
      const lines = results(box);
      if (!lines.length) { say('Enter your ZIP code above first, so there are results to send.', false); return; }
      btn.disabled = true; say('Sending…', true);
      try {
        const turnstile = window.gllfFormCheck && window.gllfFormCheck.token ? await window.gllfFormCheck.token() : '';
        const zip = (location.search.match(/[?&]zip=(\d{5})/) || [])[1] || '';
        const r = await fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ tool: box.dataset.tool, email, lines, link: location.pathname + (zip ? `?zip=${zip}` : ''), zip, consent: form.consent.checked, website: form.website.value, turnstile: turnstile || '' }) });
        const j = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(j.error || 'We could not send it right now. Please try again in a minute.');
        say(`Sent! Check ${email} in a minute or two.${j.subscribed ? ' You\'re also signed up for seasonal growing tips.' : ''}`, true);
        form.reset();
      } catch (err) { say(err && err.message ? err.message : 'We could not send it right now. Please try again in a minute.', false); }
      finally { btn.disabled = false; }
    });
  }
  const start = () => document.querySelectorAll('[data-gllf-emailme]').forEach(wire);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
